import styled from 'styled-components';

export const Wrapper = styled.section<{ hasFooter: boolean }>`
  width: 100%;
  height: auto;
  min-height: ${props =>
    props.hasFooter ? 'calc(100vh - 128px)' : 'calc(100vh - 60px)'};
  background: #ffffff;
  border-radius: 6px;
  padding: ${props =>
    `0px ${props.theme.app.padding.horizontal} ${props.theme.app.padding.vertical} ${props.theme.app.padding.horizontal}`};
`;
